import { API_TYPE } from '@umu/umu-fetch';

const BASE = '/uapi/v1';

export const TEMPLATE_API = {
    CAPABILITY_TEMPLATE_LIST: {
        url: `${BASE}/poll/get-homework-multi-eval-template`, // 获取 多维度评价 列表
        type: API_TYPE.GET,
    },
    CAPABILITY_TEMPLATE_DEL: {
        url: `${BASE}/poll/delete`, // 删除多维度评价模板
        type: API_TYPE.POST,
    },
    CAPABILITY_TEMPLATE_QUESTION: {
        url: `${BASE}/poll/get`, // 获取 多维度评价 列表
        type: API_TYPE.GET,
    },
    SAVE_CAPABILITY_TEMPLATE_QUESTION: {
        url: `${BASE}/poll/save`, // 保存 多维度评价 列表
        type: API_TYPE.GET,
    },
};
